import { Flex, Divider, Box, Text, Tooltip, useTheme } from '@chakra-ui/react';
import { InfoIcon } from '../../../../icons';
import { CodingLanguage } from '../../../../CodingLanguage';
import { WrongIcon } from '../../../../icons/WrongIcon';
import { Fragment } from 'react';
import CommonLoadingCell from '../LoadingCell/CommonLoadingCell';
import type {
  Languages,
  LanguagesRow,
} from '../../types/contributorTableTypes';

type Props = {
  languages?: Languages;
  loading: boolean;
  rowHeight?: string;
};

const LanguagesCol = ({ languages, loading, rowHeight }: Props) => {
  const { colors } = useTheme();
  return (
    <Flex
      direction="column"
      position="sticky"
      left={0}
      bg="white"
      h={'fit-content'}
      w="170px"
      zIndex={80}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        borderLeft="1px solid #E0E0E0"
        align="center"
        minH="52px"
        pl={4}
        pr={2}
        zIndex={50}
      >
        <Flex w="full" justify={'space-between'} align="center">
          <Text
            fontSize="sm"
            fontFamily="heading"
            fontWeight="medium"
            color="text.secondary2"
            w="180px"
          >
            Languages
          </Text>
          <Tooltip
            label={
              'The top 2 programming languages the developer has worked with, based on the total lines of code (LoC) they have committed.'
            }
            hasArrow
          >
            <Box>
              <InfoIcon width={17} height={17} />
            </Box>
          </Tooltip>
        </Flex>
      </Flex>

      <Divider />

      {loading
        ? [...Array(10)].map((_, index) => (
            <CommonLoadingCell key={index} rowHeight={rowHeight} />
          ))
        : languages?.map((row: LanguagesRow, index: number) =>
            row ? (
              <Fragment key={`row-${index}`}>
                <Flex
                  direction="column"
                  justify={'center'}
                  minH={rowHeight || '110px'}
                  p={3}
                  gap={2}
                  bg="white"
                  borderLeft="1px solid #E0E0E0"
                >
                  {row.map((item: string) => (
                    <CodingLanguage
                      key={item}
                      language={item}
                      fontSize="sm"
                      fontFamily="heading"
                      color="text.primary"
                    />
                  ))}
                </Flex>
                <Divider />
              </Fragment>
            ) : (
              <Fragment key={`row-${index}`}>
                <Flex
                  direction="column"
                  justify={'center'}
                  minH={rowHeight || '110px'}
                  p={3}
                  gap={2}
                  bg="white"
                  borderLeft="1px solid #E0E0E0"
                >
                  <Flex justify={'center'} align={'center'} gap={1}>
                    <Box mt={2} mr={-2}>
                      <WrongIcon
                        color={'transparent'}
                        stroke={colors.error}
                        height={23}
                        width={23}
                      />
                    </Box>
                    <Text
                      fontSize="sm"
                      color="text.primary"
                      fontWeight={'medium'}
                    >
                      No Data Available
                    </Text>
                  </Flex>
                </Flex>
                <Divider />
              </Fragment>
            )
          )}
    </Flex>
  );
};

export default LanguagesCol;
